import firebase from 'firebase';

const FireAnalyticsModule = {
  actions: {
    LOG_EVENT: (context, { eventName }) => {
      firebase.analytics().logEvent(eventName);
    },
    LOG_SESSION_DURATION_IN_EXERCISES: ({ rootState }, parameters) => {
      const { currentUser } = firebase.auth();
      if (!currentUser) return;
      const userDocId = rootState.user && rootState.user.docId;
      firebase.firestore().collection('session-duration').add({
        ...parameters,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        userId: userDocId || null,
        uid: currentUser.uid,
      });
    },
  },
};

export default FireAnalyticsModule;
